var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGradientUploadIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.546 16.7521V4.87213L6.059 8.35913L4.56901 6.82513L10.607 0.786133L16.645 6.82416L15.155 8.35815L11.668 4.87115V16.7512L9.546 16.7521ZM2.55601 22.0012C2.219 22.0079 1.88417 21.9455 1.57218 21.8179C1.2602 21.6903 0.977663 21.5002 0.741996 21.2592C0.500996 21.0235 0.310834 20.7409 0.183219 20.429C0.0556049 20.117 -0.00674589 19.7821 7.10721e-06 19.4451V15.6101H2.12099V19.4451C2.12205 19.5018 2.13466 19.5576 2.15804 19.6092C2.18143 19.6608 2.2151 19.707 2.257 19.7451C2.29511 19.787 2.34138 19.8207 2.39297 19.8441C2.44455 19.8675 2.50037 19.8801 2.557 19.8811H18.657C18.7136 19.8801 18.7695 19.8675 18.821 19.8441C18.8726 19.8207 18.9189 19.787 18.957 19.7451C18.9989 19.707 19.0326 19.6608 19.056 19.6092C19.0793 19.5576 19.0919 19.5018 19.093 19.4451V15.6101H21.214V19.4451C21.2208 19.7821 21.1584 20.117 21.0308 20.429C20.9032 20.7409 20.713 21.0235 20.472 21.2592C20.2363 21.5002 19.9538 21.6903 19.6418 21.8179C19.3298 21.9455 18.995 22.0079 18.658 22.0012H2.55601Z",
    fill: "url(#paint0_linear_14_2658)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_2658",
    x1: -0.000488281,
    y1: 11.3939,
    x2: 21.2145,
    y2: 11.3939,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF5300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FB5103"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#F04C0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#DE4322"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#C5363C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#A4265F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#7C1389"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5B03AD"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGradientUploadIcon);
export default __webpack_public_path__ + "static/media/gradient-upload-icon.5b38ab896961f44bfd1752f6b344bf5e.svg";
export { ForwardRef as ReactComponent };